import type { ClientPropertyLandDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LandFormFields } from "web_myplann/Portfolio/Forms/LandForm/LandFormFields";
import { useEditLandForm } from "web_myplann/Portfolio/Forms/LandForm/useEditLandForm";
import { RealEstateTypeRow } from "web_myplann/Portfolio/Forms/RealEstateForm/RealEstateTypeRow";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditLandFormProps = {
	propertyId: number;
	property: ClientPropertyLandDetailResponseDTO;
	detailRoute: string;
};

export const EditLandForm = ({
	propertyId,
	property,
	detailRoute,
}: EditLandFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useEditLandForm({
		propertyId,
		property,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditLand.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<RealEstateTypeRow mode="locked" value={ClientPropertyTypeEnum.Land} />
			<LandFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
